var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-progress-linear',{attrs:{"indeterminate":"","active":_vm.loading}}),(_vm.error)?_c('v-card',{attrs:{"color":"error"}},[_c('v-card-text',[_vm._v(" "+_vm._s(_vm.error)+" ")])],1):(_vm.status)?_c('p',{staticClass:"ma-2",domProps:{"innerHTML":_vm._s(_vm.status)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }